// src/components/AccountTitle.js
import React, { useState, useEffect } from "react";
import Select from "react-select";
import axios from "axios";
import swal from "sweetalert";
import $ from "jquery";
import "jquery/dist/jquery.min.js";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import { DateRangePicker } from "react-dates";
import "react-dates/lib/css/_datepicker.css";
import "react-dates/initialize";
import moment from "moment";

export default function AccountTitle(props) {
  const [items, setItems] = useState({
    Mettype: "",
    MethodId: "",
  });

  const [paymentTypes, setPaymentTypes] = useState([
    { label: "Cash", value: "1" },
    { label: "Bank", value: "2" },
  ]);

  const [paymentTitles, setPaymentTitles] = useState([]);
  const [selectedPaymentType, setSelectedPaymentType] = useState(null);
  const [selectedPaymentTitle, setSelectedPaymentTitle] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [totalDamount, setTotalDamount] = useState(0);
  const [totalPayment, setTotalPayment] = useState(0);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [focusedInput, setFocusedInput] = useState(null);

  // Fetch Payment Titles based on selected Payment Type
  const fetchPaymentTitles = async (paymentTypeId) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_APIURL}payment/GetMethod?shiftid=${paymentTypeId}&companyid=${props.companyid}`
      );
      const titles = response.data.map((method) => ({
        value: method.id,
        label: method.title,
      }));
      setPaymentTitles(titles);
    } catch (error) {
      console.error("Error fetching payment titles:", error);
      swal({ title: "Failed to load payment titles", icon: "error" });
    }
  };
  // Handle Payment Method change
  const handlePaymentTypeChange = (selectedOption) => {
    setSelectedPaymentType(selectedOption);
    setItems((prev) => ({ ...prev, Mettype: selectedOption.value }));
    fetchPaymentTitles(selectedOption.value);
  };

  // Handle Payment Title change
  const handlePaymentTitleChange = (selectedOption) => {
    setSelectedPaymentTitle(selectedOption);
    setItems((prev) => ({ ...prev, MethodId: selectedOption.value }));
  };

  const handleDateChange = ({ startDate, endDate }) => {
    setStartDate(startDate);
    setEndDate(endDate);
  };

  // Fetch data based on selected Payment Title
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedPaymentTitle) {
      swal({ title: "Please select a Payment Title", icon: "error" });
      return;
    }

    try {
      const startDateFormatted = startDate ? moment(startDate).format("YYYY-MM-DD") : null;
      const endDateFormatted = endDate ? moment(endDate).format("YYYY-MM-DD") : null;

      const response = await axios.get(
        `https://farm.royalresort.pk/api/payment/GetReportbytitle?companyid=${props.companyid}&title=${selectedPaymentTitle.label}` +
        `${startDateFormatted ? `&stDate=${startDateFormatted}` : ""}` +
        `${endDateFormatted ? `&eDate=${endDateFormatted}` : ""}`
      );
      setTableData(response.data);
      response.data.length <= 0
        ? swal({ title: "There are no Booking yet!", icon: "info" })
        : setTableData(response.data);

      const totalDamount = response.data.reduce((acc, row) => acc + (row.damount || 0), 0);
      const totalPayment = response.data.reduce((acc, row) => acc + (row.totalPayment || 0), 0);
      setTotalDamount(totalDamount);
      setTotalPayment(totalPayment);
    } catch (error) {
      console.error("Error fetching report:", error);
      swal({ title: "Failed to fetch report", icon: "error" });
    }
  };

  // Initialize DataTable when tableData updates
  useEffect(() => {
    if ($.fn.DataTable.isDataTable("#reportTable")) {
      $("#reportTable").DataTable().destroy();
    }

    if (tableData.length > 0) {
      $("#reportTable").DataTable({
        data: tableData,
        destroy: true,
        columns: [
          { data: "booking_ID", title: "Booking ID" },
          { data: "company_id", title: "Company ID" },
          { data: "damount", title: "Amount" },
          { data: "paymentType", title: "Payment Type" },
          { data: "title", title: "Agent" },
          { data: "totalPayment", title: "Total Payment" },
        ],
      });

      $("#reportTable").show().css({ width: "100%" });
    } else {
      $("#reportTable").hide();
    }
  }, [tableData]);

  return (
    <div className="row">
      <div className="col-12">
        <div className="card">
          <div className="card-header">
            <h3 className="me-auto mb-2 mt-5">Account Title Report</h3>
          </div>
          <div className="card-body">
            <div className="basic-form">
              <form onSubmit={handleSubmit}>
                <div className="row align-items-center">
                  <div className="mb-3 col-lg-4">
                    <label htmlFor="paymentMethod" className="form-label">
                      Payment Method
                    </label>
                    <Select
                      value={selectedPaymentType}
                      options={paymentTypes}
                      onChange={handlePaymentTypeChange}
                    />
                  </div>
                  <div className="mb-3 col-lg-4">
                    <label htmlFor="paymentTitle" className="form-label">
                      Payment Title
                    </label>
                    <Select
                      value={selectedPaymentTitle}
                      options={paymentTitles}
                      onChange={handlePaymentTitleChange}
                    />
                  </div>
                  <div className="mb-3 col-lg-4">
                    <label className="form-label">Date Range</label>
                    <DateRangePicker
                      startDate={startDate}
                      startDateId="start_date_id"
                      endDate={endDate}
                      endDateId="end_date_id"
                      onDatesChange={handleDateChange}
                      focusedInput={focusedInput}
                      onFocusChange={(focusedInput) => setFocusedInput(focusedInput)}
                      isOutsideRange={() => false}
                      numberOfMonths={1}
                      displayFormat="DD/MM/YYYY"
                    />
                  </div>
                  <div className="col-lg-4 d-flex align-items-center mx-auto mt-3">
                    <button type="submit" className="btn btn-primary" id="book">
                      Search
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
          {/* Table to display fetched data */}
          <div className="card-body">
            <div className="table-responsive">
              <table id="reportTable" className="display" style={{ width: "100%" }}>
                <thead>
                  <tr>
                    <th>Booking ID</th>
                    <th>Company ID</th>
                    <th>Discount</th>
                    <th>Payment Type</th>
                    <th>Title</th>
                    <th>Received Amount</th>
                  </tr>
                </thead>
                <tbody></tbody>
                <tfoot>
                  <tr>
                    <th></th>
                    <th></th>
                    <th>Total Amount </th>
                    <th></th>
                    <th></th>
                    <th>Total Received</th>
                  </tr>
                  <tr className="total_amount">
                    <td>Total:</td>
                    <td>--</td>
                    <td>{totalDamount.toLocaleString()}</td>
                    <td>--</td>
                    <td>--</td>
                    <td>{totalPayment.toLocaleString()}</td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
